import * as PropTypes from "prop-types";
import React from "react";
import {BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {getKuehlartEndpoint} from "../../../services/WertelistenService";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {LageVerortung} from "../common/LageVerortung";
import {AnlagenEinleiter} from "./AnlagenEinleiter";
import {AnlagenHeader} from "./AnlagenHeader";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";
import {KUEHLWASSER} from "../../../consts/anlagentyp";
import AnlagenFooter from "./AnlagenFooter";
import {useAnlagenstatus} from "../../../services/AnlagenService";

export default function Kuehlwasser(props) {
    const [kuehlartOptionen] = useHttpSortById(getKuehlartEndpoint);
    const [anlagenstatusOptionen] = useAnlagenstatus(props.data?.anlagenart?.id, props.data?.anlagentyp?.id, props.betriebstyp?.id);

    const abwasserbeseitigungspflichtige = props.data?.abwasserbeseitigungspflichtige ? props.data.abwasserbeseitigungspflichtige : [];

    function isDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]);
        }
        return true;
    }

    function isLageVerortungDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "s") {
            return !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]);
        }
        return true;
    }

    return (
        <div className="gridl tabsheet-content-margin">
            <AnlagenHeader
                formFactory={props.formFactory}
                disabled={isDisabled()}
                statusDisabled={!props.anlageId || isDisabled()}
                anlagenstatusOptionen={anlagenstatusOptionen.data}
                angeschlosseneAnlage={props.data?.angeschlosseneAnlage}
                anlagenstatus={props.data?.anlagenstatus}
            />
            <AnlagenEinleiter
                data={props.data}
                betriebsId={props.betriebsId}
                anlageId={props.anlageId}
                anlagentyp={KUEHLWASSER}
                formFactory={props.formFactory}
                disabled={isDisabled()}
                onChange={props.onChange}
                indirekteinleiter={props.data.indirekteinleiter}
                isButtonVisible={userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN])}
                abwasserbeseitigungspflichtige={abwasserbeseitigungspflichtige}
            />
            <div className="gridl" style={{gridTemplateColumns: "1fr"}}>
                {props.formFactory.renderAutocompleteWerteliste(
                    "kuehlart",
                    "kuehlart",
                    "Art der Kühlung",
                    kuehlartOptionen,
                    false,
                    isDisabled()
                )}
            </div>
            <LageVerortung
                formFactory={props.formFactory}
                disabled={isLageVerortungDisabled()}
                data={props.data}
                onClick={(lage) => props.onChange("lage", lage)}
                isButtonVisible={userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) || (userHasAnyRole([BETREIBER]) && !props.anlageId)}
                modus={props.modus}
            />
            <div className="gridl" style={{gridTemplateColumns: "repeat(2,max-content)"}}>
                {props.formFactory.renderCheckbox("kuehlBehandlung", "kuehlBehandlung", "Behandlung des Kühlwassers", isDisabled())}
                {props.formFactory.renderCheckbox(
                    "selbstueberwachungspflicht",
                    "selbstueberwachungspflicht",
                    "Selbstüberwachungspflicht",
                    isDisabled()
                )}
            </div>
            <AnlagenFooter
                formFactory={props.formFactory}
                withAnlagenart={props.withAnlagenart}
                withDwaAndStaLa={false}
                isDisabled={isDisabled()}/>
        </div>
    );
}

Kuehlwasser.propTypes = {
    anlageId: PropTypes.number,
    modus: PropTypes.oneOf(["l", "s"]).isRequired,
};
